export class CarritoHeader {
    lista:[{
        id:string;
        activoId: string;
        cantidad:string;
        tipoProducto:string;
        sizeID:string;
        modalidadId:string;
        //Tipo Producto 1: Libros  -- 2:Sourvenir
    }]  
  
    constructor(){
        this.lista=[{
            id:'',
            activoId:'',
            cantidad:'',
            tipoProducto:'',
            sizeID:'',
            modalidadId:''
        }]
    }
 

}
